<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 16 16"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M3.095 7.188l5.821-4.183a1 1 0 0 1 1.584.812v8.367a1 1 0 0 1-1.584.812L3.095 8.812a1 1 0 0 1 0-1.624z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
